'use client';

import LoadingSpinner from '@/components/LoadingSpinner';
import { useMountedPathname } from '@/hooks/useMountedPathname';

/**
 * Root loading boundary.
 *
 * Kept deliberately plain: this is the fallback for public pages, where a big
 * branded card talking about "your workspace and security context" both looked
 * like an authentication wall and was untrue , nothing is being authenticated.
 */
export default function RootLoading() {
  const pathname = useMountedPathname();

  const hideOnThisRoute =
    pathname?.startsWith('/dashboard') ||
    pathname?.startsWith('/preview') ||
    pathname?.startsWith('/previews') ||
    pathname === '/m' ||
    pathname?.startsWith('/m/');

  if (hideOnThisRoute) return null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <LoadingSpinner size="lg" />
    </div>
  );
}
